<template>
	<!-- Swiper -->
	<div class="swiper-container">
		<div class="swiper-wrapper">
			<div class="swiper-slide" v-for="(item,index) in ban">
				<img class="img-fluid" :src="item.img"/>
				<div class="tit">{{item.tit}}</div>
			</div>
		</div>
		<!-- Add Pagination -->
		<div class="swiper-pagination"></div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	export default {
		props: ['ban'],
		mounted() {
         	var swiper = new Swiper('.swiper-container', {
				pagination: '.swiper-pagination',
				effect: 'coverflow',
				grabCursor: true,
	            autoplay : 2000,
//	            loop:true,
				centeredSlides: true,
				slidesPerView: 'auto',
				coverflow: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true
				}
			});
		}
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	body {
		background: #fff;
		font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
		font-size: 14px;
		color: #000;
		margin: 0;
		padding: 0;
	}
	
	.swiper-container {
		width: 100%;
		padding-top: 50px;
		padding-bottom: 50px;
	}
	
	.swiper-slide {
		width: 300/@w; 
		min-width: 150px;
		height: auto;
	}
	.tit{
		position: absolute;
		left: 0;
		bottom: 0;
		text-align: center;
		width: 100%;
		padding: 10/@w 0;
		color: #FBF4E9;
		font-size: 16/@w;
		background: rgba(0,0,0,.6);
	}
</style>


// WEBPACK FOOTER //
// src/components/swiperTer/index.vue